<template>
  <!-- Logo cloud start-->
  <div class="bg-white py-24 sm:py-14">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="lg:max-w-2xl pb-8">
        <h2 class="text-base font-semibold">
          <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-yellow-400"
          >
            Optez pour la proximité
          </span>
        </h2>
        <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          {{ $t("home.stories.title") }}
        </h2>
        <h2
          class="text-center text-lg font-medium leading-8 text-black pb-10"
        ></h2>
      </div>
      <div
        class="mx-auto grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-12 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 sm:gap-y-14 lg:mx-0 lg:max-w-none lg:grid-cols-6"
      >
        <a
          href="https://projetsolaire.com/installer/case-studies/all"
          target="_blank"
        >
          <img
            class="col-span-2 w-full object-contain lg:col-span-1"
            src="https://images.ctfassets.net/1b6f0wuf6ave/HQT9DkmtjZGdzan8onJbX/d2167984b949ec3c1c342534f657aa29/Solis.png"
            alt="Solis"
            width="158"
            height="48"
          />
        </a>
        <a
          href="https://projetsolaire.com/installer/case-studies/all"
          target="_blank"
        >
          <img
            class="col-span-2 max-h-20 w-full object-contain lg:col-span-1"
            src="https://images.ctfassets.net/1b6f0wuf6ave/5cqt9kZzCwIxqQe4Aq3uS4/531d8a22eae634075798d8ae466838ce/Pros_and_Cons_of_Rooftop_Solar__5_.png"
            alt="Provence Energie Solaire Services"
            width="158"
            height="48"
          />
        </a>
        <a
          href="https://projetsolaire.com/installer/case-studies/all"
          target="_blank"
        >
          <img
            class="col-span-2 max-h-20 w-full object-contain lg:col-span-1"
            src="https://images.ctfassets.net/1b6f0wuf6ave/tf7F6B1d4xan5ATnlMPWG/8439decef3b24065c5a56d6a3e53d26b/Pros_and_Cons_of_Rooftop_Solar__3_.png"
            alt="Efficience"
            width="158"
            height="48"
          />
        </a>
        <a
          href="https://projetsolaire.com/installer/case-studies/all"
          target="_blank"
        >
          <img
            class="col-span-2 max-h-20 w-full object-contain sm:col-start-2 lg:col-span-1"
            src="https://images.ctfassets.net/1b6f0wuf6ave/7BUeeTKN6Wm62PstSOsrkP/e788427929ad7eff983b4d973422aecf/solaire_impulsion.png"
            alt="Solaire Impulsion"
            width="158"
            height="48"
          />
        </a>
        <a
          href="https://projetsolaire.com/installer/case-studies/all"
          target="_blank"
        >
          <img
            class="col-span-2 col-start-2 max-h-20 w-full object-contain sm:col-start-auto lg:col-span-1"
            src="https://images.ctfassets.net/1b6f0wuf6ave/5qrMROfWlQDfAV25sODJpZ/6fe83fcbcfc8705d4e8d077a4b39e3f6/potenciel.png"
            alt="Potenciel"
            width="158"
            height="48"
          />
        </a>
        <a
          href="https://projetsolaire.com/installer/case-studies/all"
          target="_blank"
        >
          <img
            class="col-span-2 col-start-2 max-h-20 w-full object-contain sm:col-start-auto lg:col-span-1"
            src="https://images.ctfassets.net/1b6f0wuf6ave/2MA4jS1RKdZiGHrlmtRZgh/f37c20039e79a6249b9984bcbc2adbdc/Pros_and_Cons_of_Rooftop_Solar__6_.png"
            alt="Luvie"
            width="158"
            height="48"
          />
        </a>
      </div>
    </div>
  </div>
  <!-- Logo cloud end-->
  <div class="overflow-hidden lg:mt-20">
    <div class="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
      <div
        class="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8"
      >
        <div class="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
          <h2
            class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
          >
            {{ $t("home.logo-cloud.title") }}
          </h2>
          <p class="mt-6 text-xl leading-8 text-gray-600">
            {{ $t("home.stories.description") }}
          </p>

          <router-link
            :to="{ name: 'BlogSeries', query: { series: 'stories' } }"
            class="btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 mt-8"
          >
            <span>{{ $t("home.stories.button") }}</span>
            <svg
              class="w-3 h-3 fill-current text-gray-400 shrink-0 ml-2 -mr-1"
              viewBox="0 0 12 12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z"
                fill-rule="nonzero"
              />
            </svg>
          </router-link>
        </div>
        <div
          class="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents"
        >
          <router-link
            :to="{
              name: 'BlogArticle',
              params: { slug: 'lexperience-solaire-de-philippe-et-julie' },
            }"
            class="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end"
          >
            <img
              src="https://images.ctfassets.net/1b6f0wuf6ave/6oh2p5ACAZe6LohuOTEO5B/201c829425fa85559829c0a4c6c949fb/stories-02.png"
              alt=""
              class="aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover hover:blur-sm transition duration-300"
            />
          </router-link>
          <div
            class="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8"
          >
            <router-link
              :to="{
                name: 'BlogArticle',
                params: { slug: 'lexperience-solaire-de-mathilde' },
              }"
              class="order-first flex w-64 flex-none justify-end self-end lg:w-auto"
            >
              <img
                src="https://images.ctfassets.net/1b6f0wuf6ave/7F59QEmPBDOINviNb5ptXn/442a2fc71ee6f2e46092347b499a2e76/stories-01.png"
                alt=""
                class="aspect-[4/3] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover hover:blur-sm transition duration-300"
              />
            </router-link>
            <router-link
              :to="{
                name: 'BlogArticle',
                params: { slug: 'lexperience-solaire-de-jean' },
              }"
              class="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none"
            >
              <img
                src="https://images.ctfassets.net/1b6f0wuf6ave/rMIyFCNUz7LZHCrODx9d3/43dd24dbb6f28fb616c7835a05647bb0/stories-03.png"
                alt=""
                class="aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover hover:blur-sm transition duration-300"
              />
            </router-link>
            <router-link
              :to="{
                name: 'BlogArticle',
                params: { slug: 'lexperience-solaire-de-michel' },
              }"
              class="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none"
            >
              <img
                src="https://images.ctfassets.net/1b6f0wuf6ave/1ej6LekNQvFcYwGGPO2qYl/6b3e45337a17e05b9245fc0541eb5597/stories-04.png"
                alt=""
                class="aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover hover:blur-sm transition duration-300"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
